import { MuiThemeProvider, Theme } from "@tm/components"
import { Children, PropsWithChildren, useEffect, useState } from "react"
import { createMuiTheme, DEFAULT_THEME } from "@tm/themes"
import { ThemeProviderContext } from "./ThemeProviderContext"
import { getStyleTheme } from "."

type ThemeProviderProps = PropsWithChildren

export function ThemeProvider(props: ThemeProviderProps) {
    const nextTheme = getStyleTheme() // theme was already loaded by the portal, before the Providers are rendered
    const [muiTheme, setMuiTheme] = useState<Theme | undefined>()
    useEffect(() => {
        async function lazyLoadTheme() {
            try {
                setMuiTheme(await createMuiTheme(nextTheme))
            } catch {
                // We need to create a custom MuiTheme with default values in case of an error.
                // We need the custom fields like palette.highlight; otherwise, the application does not start.
                setMuiTheme(await createMuiTheme(DEFAULT_THEME))
            }
        }
        lazyLoadTheme()
    }, [])

    return (
        <ThemeProviderContext.Provider value={nextTheme}>
            {(muiTheme && <MuiThemeProvider theme={muiTheme}>{props.children ? Children.only(props.children) : null}</MuiThemeProvider>) || null}
        </ThemeProviderContext.Provider>
    )
}
